import {
  FETCH_CONTACTS, FETCH_CONTACT
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const ContactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_CONTACTS}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_CONTACTS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_CONTACTS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const ContactReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_CONTACT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_CONTACT}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_CONTACT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

// export const createBlogReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case `${CREATE_BLOG}_PENDING`:
//       return { ...state, message: null, loading: true };

//     case `${CREATE_BLOG}_FULFILLED`:
//       return {
//         ...state,
//         loading: false,
//         data: action.payload.results ? action.payload.results : {},
//         message: action.payload.message,
//       };

//     case `${CREATE_BLOG}_REJECTED`:
//       return {
//         ...state,
//         loading: false,
//         data: null,
//         message: `${action.payload.data}`,
//       };

//     default:
//       return state;
//   }
// };

// export const updateBlogReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case `${UPDATE_BLOG}_PENDING`:
//       return { ...state, message: null, loading: true };

//     case `${UPDATE_BLOG}_FULFILLED`:
//       return {
//         ...state,
//         loading: false,
//         data: action.payload.results ? action.payload.results : {},
//         message: action.payload.message,
//         error: action.payload.error,
//       };

//     case `${UPDATE_BLOG}_REJECTED`:
//       return {
//         ...state,
//         loading: false,
//         data: null,
//         message: `${action.payload.data}`,
//       };

//     default:
//       return state;
//   }
// };

// export const deleteBlogReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case `${DELETE_BLOG}_PENDING`:
//       return { ...state, message: null, loading: true };

//     case `${DELETE_BLOG}_FULFILLED`:
//       return {
//         ...state,
//         loading: false,
//         data: action.payload ? action.payload.message : {},
//         message: action.payload.message,
//         error: action.payload.error,
//       };

//     case `${DELETE_BLOG}_REJECTED`:
//       return {
//         ...state,
//         loading: false,
//         data: null,
//         message: `${action.payload.data}`,
//       };

//     default:
//       return state;
//   }
// };
